"use client"

import { motion } from "framer-motion"

const questions = [
  "What pulls your attention \u2014 when nobody\u2019s watching?",
  "What pattern do you keep repeating \u2014 without knowing it?",
  "What can everyone see about you \u2014 except you?",
  "How much of your thinking is talking to itself?",
  "Are you becoming who you want to be \u2014 or drifting somewhere you haven\u2019t chosen?",
]

export function TheQuestions() {
  return (
    <section
      className="px-6 py-24 sm:py-32"
      style={{ backgroundColor: "var(--brand-white-hills)" }}
    >
      <div className="mx-auto max-w-2xl">
        {/* Intro */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-[var(--font-instrument-serif)] text-[24px] leading-snug sm:text-[28px]"
            style={{ color: "var(--brand-graphite)" }}
          >
            You&rsquo;ve spent months talking to AI.
            <br />
            What did it learn about you that you haven&rsquo;t yet?
          </h2>
          <p
            className="mt-4 text-[16px]"
            style={{ color: "var(--brand-cliff)" }}
          >
            Five questions your conversations can answer.
          </p>
        </motion.div>

        {/* Questions */}
        <div className="mt-14 flex flex-col gap-8 sm:mt-16 sm:gap-10">
          {questions.map((q, i) => (
            <motion.p
              key={i}
              className="font-[var(--font-instrument-serif)] text-[20px] leading-snug sm:text-[22px]"
              style={{
                color: "var(--brand-graphite)",
                borderLeft: "3px solid var(--brand-star)",
                paddingLeft: "1.5rem",
              }}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              {q}
            </motion.p>
          ))}
        </div>

        {/* Closing */}
        <motion.p
          className="mt-14 text-center font-[var(--font-instrument-serif)] text-[18px] italic sm:mt-16"
          style={{ color: "var(--brand-cliff)" }}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Your answers are already in your conversations.
        </motion.p>
      </div>
    </section>
  )
}
